// extracted by mini-css-extract-plugin
export default {"wrap":"Ks-z","logoContainer":"Ls-z","brandImg":"Ms-z","logoImg":"Ns-z","logoButton":"Os-z"};